<!--
  A balance, the same on every screen (Miles, 2026-10-23): a plain figure from the person's side,
  like a bank app. Minus and red is what they owe, plus and green is a credit, $0.00 is square.
  The sign always goes with the color, so it reads right on a printout or a screen reader.
  `cents` uses the core's sign: positive means they owe (you, or the treasurer).
-->
<script lang="ts">
  import { figure, tone } from "../lib/personCard.ts";

  let { cents, you = false, big = false }: { cents: number; you?: boolean; big?: boolean } = $props();
</script>

<span class="amt num {you ? '' : tone(cents)}" class:big>{you ? "—" : figure(cents)}</span>

<style>
  .amt {
    font-weight: 650;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }
  .big {
    font-size: var(--t-lg);
  }
  .owes {
    color: var(--owes);
  }
  .credit {
    color: var(--ok);
  }
</style>
